import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class TTRecordSlaExceedReportService extends Service{
    constructor() {
        super();
        this.baseURL = 'ttRecordSlaExceedReport';
    }

    findSlaByStartDateAndEndDate(dateStart,dateEnd) {
        return fetch(SERVER_URL + this.baseURL + '/findSlaByStartDateAndEndDate/'+dateStart+'/'+dateEnd, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}